<template>
    <div>
        <div class="calendar_wrap" style="width:100%; height:100%; display:grid; place-items: center;z-index:100;" @click.stop="() => { isShowCalendar = false }">
            <div :class="isChangeWidth ? 'change_width' : 'un_change_width'" style="border-radius:15px; max-width:450px; overflow: hidden;" @click.stop="() => { }">
                <CalendarClass :isModify="isModify" :is-toggle-hidden="true" :isFirstShowMonth="true" :startDate="initDate" :selectDateCallback="selectDateHandler" />
            </div>
        </div>
    </div>
</template>

<script>
import CalendarClass from "./CalendarClass";
import moment from 'moment';

export default {
    name: "ScheduleSettingCalendar",
    components: { CalendarClass },
    props: {
        detectSelectDate: {
            type: Function,
            default: () => { }
        },
        signalShowCalender: {
            type: Boolean,
            default: false,
        },
        initDate: {
            type: String,
            default: '',
        },
        isModify: {
            type: Boolean,
            default: false
        },
        isChangeWidth: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        signalShowCalender() {
            this.isShowCalendar = true;
        }
    },
    data() {
        return {
            isShowCalendar: false,
            calendar_date: moment().format('YYYY-MM-DD'),
        }
    },
    methods: {
        showCalendar() {
            this.isShowCalendar = true;
        },
        selectCalendarDate() {
            const day_str = ['일', '월', '화', '수', '목', '금', '토'];
            this.detectSelectDate(this.calendar_date, day_str[moment(this.calendar_date).day()]);
            this.isShowCalendar = false;
        },
        selectDateHandler(date) {
            this.calendar_date = date;
            this.selectCalendarDate()
        },
    }

}
</script>

<style scoped>
.calendar_wrap {
    top: 0px;
}

.bottom-enter-active,
.bottom-leave-active {
    transition: top .5s;
}

.bottom-enter,
.bottom-leave-to {
    top: 100%;
}

.un_change_width {
    min-width:350px;
    width: 90%;
}

.change_width {
    width: 100%;
}
</style>